import { IComponentOptions, IController, IIntervalService } from 'angular';
import { StorageService } from '../../core/providers/storage/storage.service';
import {
  IBalance,
  PaymentService
} from '../../core/services/payment/payment.service';
import { IMenuItem, menuItems } from './menu.items';
import { AuthService } from '../../core/services/auth/auth.service';
import './dashboard.component.scss';
import { User } from '../../core/entities/user';
import { MailboxService } from '../mailbox/services';
import { each } from 'lodash-es';
import { MailboxQuery } from '../mailbox/shared/mailbox-query';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ChatService } from '../chat/services/chat-service';
import { Subscription } from 'rxjs';
import { CvService } from '../../core/services/cv.service';
import { UserService } from '../../core/services/user/user.service';

class DashboardController implements IController {
  static $inject = [
    'StorageService',
    'AuthService',
    'PaymentService',
    'MailboxService',
    '$interval',
    'ChatService',
    'CvService',
    'UserService'
  ];
  eventBinder: BehaviorSubject<any> = new BehaviorSubject(null);
  unreadSubscription: Subscription;
  onReadSubscription: Subscription;
  onReadManySubscription: Subscription;
  unreadCvSubscribtion: Subscription;
  counter: number;

  private isSidebarOpened: boolean;
  private sidebarItems: IMenuItem[];

  private mailQueryLimit = 100;
  private updateIntervalTime = 1000 * 30; // 30 seconds
  private updateInterval; // update balance interval promise

  // private updateMailInterval = 1000 * 1; // 1 seconds @todo change this! HOTFIX
  // private updateMailInterval = 1000 * 10; // 10 seconds
  private updateMailFunc; // update balance interval promise
  // counters for menu mail items
  private counters = {
    all: 0,
    admin: 0,
    business: 0,
    finance: 0,
    adminImp: 0,
    businessImp: 0,
    financeImp: 0,
    incomingCV: 0,
    chat: 0
  };

  constructor(
    private storageService: StorageService,
    private authService: AuthService,
    private paymentService: PaymentService,
    private mailboxService: MailboxService,
    private $interval: IIntervalService,
    private chatService: ChatService,
    private cvService: CvService,
    private userService: UserService
  ) {}

  get balance(): IBalance {
    return this.paymentService.balance;
  }

  get user(): User {
    return this.authService.user;
  }

  $onInit() {
    this.startUpdatingBalance();
    this.checkMail();
    // this.startUpdatingMails();
    this.updateSidebarItems();
    this.checkSmartServices();
    this.isSidebarOpened = !!this.storageService.get('isSidebarOpened');
    this.unreadSubscription = this.chatService
      .onUnreadMessages()
      .subscribe((res) => {
        this.counters['chat'] = res;
      });
    this.unreadCvSubscribtion = this.cvService.cvCount.subscribe((res) => {
      this.counters['incomingCV'] = res;
    });
    this.chatService.getUnread();
    this.cvService.getNewCv();
    this.onRead();
  }

  checkSmartServices() {
    this.userService.getUserActiveServices().then((res) => {
      this.counters['smartService'] = res.count;
    });
  }

  $onDestroy() {
    this.stopUpdatingBalance();
    this.unreadSubscription.unsubscribe();
    this.onReadSubscription.unsubscribe();
    this.onReadManySubscription.unsubscribe();
  }

  onRead() {
    this.onReadSubscription = this.mailboxService.$readEmail.subscribe(
      (res) => {
        if (res) {
          console.log(res);
          this.counters[res]--;
          this.counters['all']--;
        }
      }
    );

    this.onReadManySubscription = this.mailboxService.$readMany.subscribe((res) => {
      if (res) {
        this.checkMail();
      }
    });
  }

  toggleSidebar() {
    this.storageService.put('isSidebarOpened', !this.isSidebarOpened);
  }

  onSidebarToggle({ isOpened }) {
    this.isSidebarOpened = isOpened;
  }

  getCounter = (key) => {
    return key ? this.counters[key] : undefined;
  };

  private updateSidebarItems() {
    const user = this.authService.user;
    this.sidebarItems = menuItems.filter((item) =>
      item.roles.includes(user.baseRoleName)
    );
  }

  private startUpdatingBalance() {
    this.updateInterval = this.$interval(() => {
      this.paymentService.getBalance().catch((err) => {
        console.log(err);
      });
    }, this.updateIntervalTime);
  }

  private stopUpdatingBalance() {
    if (this.updateInterval) {
      this.$interval.cancel(this.updateInterval);
    }
  }

  // private startUpdatingMails() {
  //   this.updateMailFunc = this.$interval(() => this.checkMail(),
  //     this.updateMailInterval);
  // };

  private stopUpdatingMails() {
    if (this.updateMailFunc) {
      this.$interval.cancel(this.updateMailFunc);
    }
  }

  private checkChatMessages() {}

  private checkMail() {
    // check if we are logged in
    if (!this.authService.isLoggedIn()) {
      return;
    }

    const queries: any = {
      admin: {
        type: 'admin',
        page: 1,
        limit: this.mailQueryLimit
      },
      adminImp: {
        type: 'admin',
        important: true,
        page: 1,
        limit: this.mailQueryLimit
      },
      finance: {
        type: 'finance',
        page: 1,
        limit: this.mailQueryLimit
      },
      financeImp: {
        type: 'finance',
        important: true,
        page: 1,
        limit: this.mailQueryLimit
      },
      business: {
        type: 'business',
        page: 1,
        limit: this.mailQueryLimit
      },
      businessImp: {
        type: 'business',
        important: true,
        page: 1,
        limit: this.mailQueryLimit
      }
    };

    // for each type - get emails
    let total = 0;
    let i = 0;
    each(queries, (mq: MailboxQuery, key: string) => {
      this.mailboxService.getMails(mq).then((mailsData) => {
        console.log(mailsData);
        // count unread emails in response
        this.counters[key] = mailsData.mails.reduce((unreadCount, mail) => {
          return mail.is_read ? unreadCount : unreadCount + 1;
        }, 0);
        if (!mq.important) {
          total += this.counters[key];
        }
        // on last mailbox response - update counters.all to prevent nunmber flickering
        if (++i === 6) {
          console.log('[DASHBOARD] total UPD:', key, i, total);
          this.counters.all = total;
        }
        // console.log('[DASHBOARD] get emails', key, this.counters);
      });
    });
  }
}

export const DashboardComponent: IComponentOptions = {
  controller: DashboardController,
  template: require('./dashboard.component.html'),
  bindings: {
    $transition$: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/dashboard/dashboard.component.ts